import React, { ChangeEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { InputControl } from "@bst/react-ui"
import { RolesDropdown } from "./RolesDropdown"
import { RoleDTO } from '../../../apiclients/bstinsights';


/**
*
* Render AddUser component with Form and Handlers
*
* @param handleUsername - Function that handles with username form field
* @param handleEmail - Function that handles with email form field
* @param handleUserRoles - Function that handles with user roles checkboxes form field
* @param username - Returns the value of username form field
* @param email - Returns the value of email form field
* @param emailExists - Check for existing matching email address
* @param userRoles - Returns the value of user roles form field
* @param dataUserRoles - Bring the data array items to compose user roles checkboxes
*
* @privateRemarks
* @state
*/

type Props = {
  handleUsername: ChangeEventHandler<HTMLInputElement>
  handleEmail: ChangeEventHandler<HTMLInputElement>
  handleUserRoles: (roleId: number) => void
  username: string,
  email: string,
  userRoles: number[],
  dataUserRoles: Required<RoleDTO>[],
  disabledButton: boolean,
  emailExists: boolean | null
}

const AddUser = ({
  handleUsername,
  handleEmail,
  handleUserRoles,
  username,
  email,
  userRoles,
  dataUserRoles,
  disabledButton,
  emailExists
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="add-user-modal-content" data-testid="AddUser-box">
      <InputControl
        icon="icon-profile"
        label={t("addUser.labelName")}
        data-testid="user-name"
        value={username}
        onChange={handleUsername}
      />
      <InputControl
        icon="icon-email"
        label={t("addUser.labelEmail")}
        data-testid="user-email"
        value={email}
        onChange={handleEmail}
        error={emailExists ? t("addUser.emailExists") : undefined}
      />
      <RolesDropdown
        label={t("addUser.labelUserRoles")}
        disabled={disabledButton}
        dataSource={dataUserRoles}
        selectedRoles={userRoles}
        handleUserRoles={handleUserRoles}
      />
    </div>
  );
};
export default AddUser;
